<template>
  <el-card>
    <div class="header-container">
      <div class="header">
        <el-button
          @click="lockOnAnalytics"
          :icon="navbarVisible ? 'el-icon-unlock' : 'el-icon-lock'"
          style="padding: 0.5rem"
        />
        <p class="header-title">Live Chat Supervisor Dashboard</p>
        <el-select
          :value="selectedDepartments"
          multiple
          collapse-tags
          placeholder="Departments"
          @change="handleDepartmentChange"
        >
          <el-option-group label="FILTER BY DEPARTMENT">
            <el-option
              v-for="dept in departments"
              :key="dept.name"
              :label="dept.name"
              :value="dept.value"
            ></el-option>
          </el-option-group>
        </el-select>
      </div>
      <div class="datetime-container">
        <p class="time">{{ currentTime }}</p>
        <p class="date">{{ currentDate }}</p>
      </div>
    </div>
  </el-card>
</template>
<script>
import moment from 'moment-timezone';
import { liveAnalyticsMixin } from '@/mixins/liveAnalytics';

export default {
  mixins: [liveAnalyticsMixin],
  props: {
    selectedDepartments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const date = moment().local();

    return {
      $timeInterval: null,
      currentTime: date.format('H:mm:ss A'),
      currentDate: date.format('DD MMM YYYY'),
    };
  },
  computed: {
    navbarVisible() {
      return this.$store.state.navbarVisible;
    },
    isLockOnLiveAnalytics() {
      return this.$store.state.supervisor.isLockOnLiveAnalytics;
    },
  },
  methods: {
    lockOnAnalytics() {
      this.$store.commit('SET_NAVBAR_VISIBLE', !this.navbarVisible);
      this.$store.commit(
        'supervisor/SET_LOCK_ON_LIVE_ANALYTICS',
        !this.isLockOnLiveAnalytics,
      );
    },
    handleDepartmentChange(value) {
      this.$emit('update:selectedDepartments', value);
    },
  },
  mounted() {
    this.$timeInterval = setInterval(() => {
      const date = moment().local();

      this.currentTime = date.format('H:mm:ss A');
      this.currentDate = date.format('DD MMM YYYY');
    }, 1000);
  },
  beforeDestroy() {
    if (this.$timeInterval) {
      clearInterval(this.$timeInterval);
    }
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  justify-content: space-between;

  .header {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &-title {
      font-size: 1.5rem;
      font-weight: 700;
    }
  }
}

.datetime-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  p {
    margin: 0.25rem 0;
  }

  .time {
    font-size: 1.3rem;
    font-weight: 700;
  }

  .date {
    font-size: 0.8rem;
    font-weight: 500;
  }
}
</style>
